// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Poppins_b2153f', '__Poppins_Fallback_b2153f'","fontStyle":"normal"},"className":"__className_b2153f","variable":"__variable_b2153f"};